@if (breadcrumbs$ | async; as breadcrumbs) {
  @if (breadcrumbs.length) {
    <section
      [class.breadcrumbs-section--with-back-to-search-results]="showBackToSearchResults"
      class="breadcrumbs-section"
    >
      <nav aria-label="Breadcrumbs">
        <ftr-scrollable [contentHasShadow]="false">
          <ul
            class="breadcrumbs"
            data-track-group="Breadcrumbs"
            [class.breadcrumbs__collapsible]="collapseOnSmallDevices && previousPageLink"
            [class.force-collapse]="forceBreadcrumbsCollapse"
          >
            @for (breadcrumb of breadcrumbs; track breadcrumb; let last = $last) {
              @if (!last) {
                <li class="breadcrumbs__item">
                  <a
                    class="breadcrumbs__link"
                    [class.breadcrumbs__collapsible]="collapseOnSmallDevices"
                    data-track
                    [routerLink]="[breadcrumb.link.url]"
                    [queryParams]="breadcrumb.link.queryParams"
                    >{{ breadcrumb.label }}</a
                  >
                </li>
                <li class="breadcrumbs__divider">
                  <ftr-icon icon="KeyboardArrowRight" size="Medium" color="GreyLight" align="Bottom"></ftr-icon>
                </li>
              } @else {
                <li class="breadcrumbs__item--current">
                  {{ breadcrumb.label }}
                </li>
              }
            }
          </ul>
          @if (collapseOnSmallDevices && previousPageLink) {
            <ul class="breadcrumbs">
              <li class="breadcrumbs__item--back" [class.force-collapse]="forceBreadcrumbsCollapse">
                <a
                  class="breadcrumbs__link breadcrumbs__link--back"
                  data-track
                  [routerLink]="[previousPageLink.url]"
                  [queryParams]="getPreviousPageQueryParams(previousPageLink.queryParams)"
                  ><ftr-icon icon="KeyboardArrowLeft" size="Medium" color="GreyLight" align="Bottom"> </ftr-icon>
                  @if (!forceHideBreadcrumbBackText) {
                    <span>{{ alternativeBreadcrumbBackText ?? 'Back' }}</span>
                  }
                </a>
              </li>
            </ul>
          }
        </ftr-scrollable>
      </nav>
    </section>
  }
}
